define([
    "jquery",
    "underscore",
    "marionette",
    "select2",
    "select2-lang/es",
    "select2-lang/ja",
    "select2-lang/ko",
    "select2-lang/zh-CN"
], function($, _, Marionette) {
    return Marionette.ItemView.extend({

        select2El : null,
        defaultSelect: null,

        defaultValue : -1,
        defaultText : "서버를 선택해주세요",

        initialize: function(config){
            // We can use external configuration for our select2,
            config.defaultValue = !_.isEmpty(config.defaultValue) ? config.defaultValue : this.defaultValue;
            config.defaultText = !_.isEmpty(config.defaultText) ? config.defaultText : this.defaultText;

            _.extend( this , config);
            this.initSelect2();
        },

        onAttach: function(){
            this.initSelect2();
        },

        initSelect2: function(){
            var data = [
                {
                    "id": 0,
                    "text": "All Servers",
                },
                {
                    "id": 1,
                    "text": "LandFX-Live",
                },
                {
                    "id": 4,
                    "text": "LandFX-Live MT5",
                },
                {
                    "id": 7,
                    "text": "LandFX-Live2",
                },
                {
                    "id": 8,
                    "text": "LandFX-Live3",
                }
            ];
            data.map(datum => {
                if(datum.id == this.defaultSelect)
                    datum.selected = true;
                return datum;
            })

            this.select2El.select2({
                language: window.lang != "zh_CN" ? window.lang.substring(0, 2) : "zh-CN",
                theme: "bootstrap",
                data: data,
            });

            // After initializing the select2 we need to set the initial value manually
            this._setInitialValue();
        },

        _setInitialValue : function(){
            if(this.defaultValue != -1){
                this.select2El.append('<option value="'+this.defaultValue+'" selected="selected">'+this.defaultText+'</option>');
                this.select2El.trigger('change');
            }
        },

        getValue: function(){
            return this.select2El.val();
        }
    });
});
